<template>
  <div
    class="scmcc-login-page"
    :style="{
      backgroundImage: `url(${envConst.SCMCC_HOST}/images/sign_bgtexture.png)`
    }"
  >
    <div class="login-page-wrapper">
      <div class="banner">
        <div class="banner-wrapper">
          <h2 class="title">为您留住每一位客户</h2>
          <h3 class="sub-title">您创造伟大的成就，我们提供美满的服务</h3>
          <img
            class="sign-image"
            :src="`${envConst.SCMCC_HOST}/images/sign_pic.png`"
          />
        </div>
      </div>
      <div class="content">
        <div class="scmcc-register-form-wrapper">
          <div :class="['errorInfo', { noShow: !errorInfo }]">
            {{ errorInfo }}
          </div>
          <div class="scmcc-register-logo">
            <p class="register-title">欢迎注册xxxxx</p>
          </div>
          <Form
            class="scmcc-register-form"
            ref="formValidate"
            :model="Register2Form"
          >
            <FormItem class="scmcc-register-form-item">
              <i-input
                filterable
                clearable
                placeholder="请输入企业名称"
                v-model="Register2Form.name"
                @on-clear="clearName"
                @on-blur="uniqueName"
                @enter="handleSubmit"
              ></i-input>
            </FormItem>
            <FormItem class="scmcc-register-form-item">
              <i-input
                filterable
                clearable
                placeholder="请输入企业域名"
                v-model="Register2Form.domainName"
                @on-blur="uniqueDomain"
                @enter="handleSubmit"
              ></i-input>
            </FormItem>
            <FormItem class="scmcc-register-form-item">
              <i-input
                filterable
                clearable
                placeholder="请输入用于登录的邮箱"
                v-model="Register2Form.email"
                @on-blur="uniqueEmail"
                @enter="handleSubmit"
              ></i-input>
              <i-input class="hide-input"></i-input>
            </FormItem>
            <FormItem class="scmcc-register-form-item">
              <i-input type="password" class="hide-input"></i-input>
              <i-input
                placeholder="请输入同时包含字母和数字的6-16位密码"
                :type="passwordHidden && 'password'"
                v-model="Register2Form.password"
                @on-blur="handlePassword"
                @enter="handleSubmit"
              >
                <template v-slot:suffix>
                  <img
                    class="scmcc-register-form-item-icon"
                    :src="
                      passwordHidden
                        ? require('../assets/images/login-page/ico_zhengyan_dis@2x.png')
                        : require('../assets/images/login-page/ico_biyan_dis@2x.png')
                    "
                    @click="passwordHidden = !passwordHidden"
                  />
                </template>
              </i-input>
            </FormItem>
            <FormItem class="scmcc-register-form-item lastly">
              <Button
                type="primary"
                long
                :loading="loading"
                :disabled="disabled"
                @click="handleSubmit"
                >完成！进入系统</Button
              >
            </FormItem>
          </Form>
          <p class="bottom-tip-text jump-text">
            已有账户，直接
            <span @click="toLogin">登录</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { stringify } from 'qs'
import envConst from '../env-const.js'
import { setTimeout } from 'timers'
import getPreData from '../getPreData.js'
import { pages } from '@/router/routes.js'
export default {
  name: 'register2',
  data: () => ({
    envConst,
    errorInfo: '',
    passwordHidden: true,
    loading: false,
    Register2Form: {
      name: '',
      domainName: '',
      email: '',
      password: '',
      tel: ''
    },
    nameUnique: false,
    domainUnique: false,
    emailUnique: false,
    disabled: false,
    tenants: [],
    locked: false
  }),
  created() {
    this.Register2Form.tel = this.$route.params.tel
  },
  methods: {
    toLogin() {
      this.$router.push('./login')
    },
    getTenant() {
      this.$http
        .get('/sctm/sctmtenantinfos/getTenantByState')
        .then(({ data }) => {
          if (data.returnCode === 0) {
            this.tenants = data.beans
          }
        })
    },
    getPinYin() {
      let PinYin = this.$utils.ConvertPinyin(this.Register2Form.name)
      this.Register2Form.domainName = PinYin
    },
    clearName() {
      this.Register2Form.name = ''
      this.Register2Form.domainName = ''
    },
    uniqueName() {
      let regName = new RegExp(/^[a-zA-Z0-9\u4e00-\u9fa5]{4,20}$/)
      if (!this.Register2Form.name) {
        this.errorMesage('请输入企业名称')
        return
      }
      if (!regName.test(this.Register2Form.name)) {
        this.errorMesage('请输入4-20位企业名称')
        return
      }
      this.getPinYin()
      this.$http
        .get('/sctm/NKsctmtenantinfos/validateNKTenant', {
          params: { validateType: 1, tenantName: this.Register2Form.name }
        })
        .then(({ data }) => {
          console.log('企业名称校验')
          console.log(data)
          if (data.returnCode == 0) {
            if (data.bean) {
              this.nameUnique = true
              this.uniqueDomain()
            } else {
              this.errorMesage('该企业名称已存在')
              this.nameUnique = false
              return
            }
          } else {
            this.nameUnique = false
            this.errorMesage(data.returnMessage)
          }
        })
        .catch(function(er) {
          console.log(er)
        })
    },
    uniqueDomain() {
      let regDomain = new RegExp(/^[a-zA-Z0-9]{3,10}$/)
      if (!this.Register2Form.domainName) {
        this.errorMesage('请输入企业域名')
        return
      }
      if (!regDomain.test(this.Register2Form.domainName)) {
        this.errorMesage('请输入3-10位企业域名，包含英文、数字')
        return
      }
      this.$http
        .get('/sctm/NKsctmtenantinfos/validateNKTenant', {
          params: { validateType: 4, domainName: this.Register2Form.domainName }
        })
        .then(({ data }) => {
          console.log('企业域名校验')
          console.log(data)
          if (data.returnCode == 0) {
            if (data.bean) {
              this.domainUnique = true
            } else {
              this.errorMesage('该域名已存在')
              this.domainUnique = false
              return
            }
          } else {
            this.domainUnique = false
            this.errorMesage(data.returnMessage)
          }
        })
        .catch(function(er) {
          console.log(er)
        })
    },
    uniqueEmail() {
      let regEmail = new RegExp(
        /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,7})$/
      )
      if (!this.Register2Form.email) {
        this.errorMesage('请输入邮箱')
        return
      }
      if (!regEmail.test(this.Register2Form.email)) {
        this.errorMesage(
          '请输入正确格式的邮箱，如：example@cmos.chinamobile.com'
        )
        return
      }
      if (
        this.Register2Form.email.length < 6 ||
        this.Register2Form.email.length > 50
      ) {
        this.errorMesage('请输入6-50位长度邮箱')
        return
      }
      this.$http
        .get('/sctm/NKsctmtenantinfos/validateNKTenant', {
          params: { validateType: 3, userEmail: this.Register2Form.email }
        })
        .then(({ data }) => {
          console.log('企业邮箱校验')
          console.log(data)
          if (data.returnCode == 0) {
            if (data.bean) {
              this.emailUnique = true
            } else {
              this.errorMesage('该邮箱已存在')
              this.emailUnique = false
              return
            }
          } else {
            this.emailUnique = false
            this.errorMesage(data.returnMessage)
          }
        })
        .catch(function(er) {
          console.log(er)
        })
    },
    handlePassword() {
      let regPassward = new RegExp(
        /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
      )
      if (!this.Register2Form.password) {
        this.errorMesage('请输入密码')
        return
      }
      if (!regPassward.test(this.Register2Form.password)) {
        this.errorMesage('请输入同时包含字母和数字的6-16位密码')
        return
      }
    },
    handleSubmit() {
      let regName = new RegExp(/^[a-zA-Z0-9\u4e00-\u9fa5]{4,20}$/)
      let regDomain = new RegExp(/^[a-zA-Z0-9]{3,10}$/)
      let regEmail = new RegExp(
        /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,7})$/
      )
      let regPassward = new RegExp(
        /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
      )

      if (!this.Register2Form.name) {
        this.errorMesage('请输企业名称')
        return
      }
      if (!regName.test(this.Register2Form.name)) {
        this.errorMesage('请输入4-20位企业名称')
        return
      }
      if (!this.nameUnique) {
        this.errorMesage('该企业名称已存在')
        return
      }
      if (!this.Register2Form.domainName) {
        this.errorMesage('请输入企业域名')
        return
      }
      if (!regDomain.test(this.Register2Form.domainName)) {
        this.errorMesage('请输入3-10位企业域名，包含英文、数字')
        return
      }
      if (!this.domainUnique) {
        this.errorMesage('该域名已存在')
        return
      }
      if (!this.Register2Form.email) {
        this.errorMesage('请输入邮箱')
        return
      }

      if (!regEmail.test(this.Register2Form.email)) {
        this.errorMesage(
          '请输入正确格式的邮箱，如：example@cmos.chinamobile.com'
        )
        return
      }
      if (
        this.Register2Form.email.length < 6 ||
        this.Register2Form.email.length > 50
      ) {
        this.errorMesage('请输入6-50位长度邮箱')
        return
      }
      if (!this.emailUnique) {
        this.errorMesage('该邮箱已存在')
        return
      }
      if (!this.Register2Form.password) {
        this.errorMesage('请输入密码')
        return
      }
      if (!regPassward.test(this.Register2Form.password)) {
        this.errorMesage('请输入同时包含字母和数字的6-16位密码')
        return
      }

      this.disabled = true

      // 云客服注册接口
      let params = {
        domainName: this.Register2Form.domainName,
        tenantName: this.Register2Form.name,
        tenantPhone: this.Register2Form.tel,
        userEmail: this.Register2Form.email,
        userPwd: this.$encrypt.encrypt(this.Register2Form.password),
        abilityId: 60000011,
        tenantSource: '公司官网'
      }
      this.$http
        .post('/sctm/NKsctmtenantinfos/registerUser', params, {
          transformRequest: [data => stringify(data)]
        })
        .then(({ data }) => {
          if (data.returnCode == 0) {
            // 调用登陆接口
            this.loginSubmit()
          } else {
            this.disabled = false
            this.errorMesage(data.returnMessage)
          }
        })
        .catch(function(er) {
          this.disabled = false
          console.log(er)
        })
    },
    loginSubmit() {
      let loginForm = {
        domainName: this.Register2Form.domainName,
        username: this.Register2Form.tel,
        //  username: this.Register2Form.email,
        password: this.$encrypt.encrypt(this.Register2Form.password)
        // checkCode: ''
      }
      // 调用登录接口
      this.$http
        .post('/sctm/auth/login', loginForm, {
          transformRequest: [data => stringify(data)]
        })
        .then(res => {
          let { msgCode } = res.data.bean
          // 接口响应失败
          if (msgCode === 0) {
            this.$http('/sctm/auth/logOut').then(() => {
              this.$store.commit('main/user/clear')
              this.loginSubmit()
            })
          } else if (msgCode === 1) {
            Cookies.remove('needCheckCode')
            getPreData(this.$context).then(() => {
              this.$moduleLoader(this.$store.state.main.user.modules).then(
                () => {
                  this.$addRoutes(pages)
                  this.$store.commit('main/setModulesCompleted', true)
                  this.$ws()
                  this.$router.push({
                    name: 'home',
                    params: {
                      tenantId: res.data.bean.userInfoBean.tenantId,
                      showAddMessage: true
                    }
                  })
                }
              )
            })
          } else {
            this.loading = false
            if (res.data.bean.needCheckCode === '1') {
              this.getCheckCode()
              this.needCheckCode = true
              Cookies.set('needCheckCode', 1)
            }
            if (res.data.bean.isLocked === '1') {
              this.lockTime = res.data.bean.userErrLockedDate / 60
              let errorMesage =
                this.lockTime > 0
                  ? `该账号被锁定，${this.lockTime}分钟后可刷新重试`
                  : '该账号被锁定，请联系管理员'
              this.errorMesage(errorMesage)
            } else {
              this.errorMesage(res.data.bean.msgMessage)
            }
          }
        })
    },
    // 显示登录错误信息
    errorMesage(error) {
      this.errorInfo = error
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.errorInfo = ''
        this.timer = null
      }, 3000)
    }
  }
}
</script>
<style lang="stylus">
.scmcc-login-page
  height 100%
  width 100%
  overflow-y auto
  background #F3F6FC
  background-position center bottom
  background-repeat repeat-x

  .login-page-wrapper
    position relative
    width 100%
    max-width 1440px
    min-height 900px
    height 100%
    margin 0 auto

  .banner
    width 50%
    text-align center
    float left
    margin-top 128px
    user-select none

    .banner-wrapper
      display flex
      flex-flow column
      justify-content center
      height 683px

    .title
      font-size 46px
      color #1D1D26
      letter-spacing 2.3px

    .sub-title
      font-size 22px
      color #1D1D26
      letter-spacing 1.8px

    .sign-image
      width 100%
      max-width 785px

  .content
    position relative
    flex auto
    z-index 1

  .scmcc-register-form-wrapper
    position relative
    width 480px
    padding 52px 53px 52px 50px
    border-radius 10px
    background #FFFFFF
    box-shadow 0 0 26px 0 rgba(47, 92, 184, 0.4)

    .errorInfo
      position absolute
      background #F8DDDC
      border-radius 4px
      text-align center
      line-height 52px
      width 480px
      height 52px
      font-size 16px
      color #E76461
      top 0
      left 0

      &.noShow
        display none

    .scmcc-register-logo
      display flex
      align-items center
      justify-content center
      margin 0 0 32px 0

      .register-title
        color #04cbd8
        font-size 30px
        font-weight bold

      .scmcc-register-logo-text
        font-size 16px
        font-weight 600
        color rgba(54, 107, 187, 1)
        line-height 1
        margin-left 8px

    .bottom-tip-text
      color #5e5f77
      font-size 14px

      span
        color #04cbd8
        cursor pointer

    .jump-text
      margin-top 28px
      text-align center

    .scmcc-register-form
      .scmcc-register-form-item
        margin-bottom 24px

        &.lastly
          margin-top 40px
          margin-bottom 0

        .ivu-select-selection
          height 52px

        .hide-input
          width 0
          opacity 0

        .ivu-select-input, .ivu-input, .ivu-btn
          height 52px
          padding-left 20px
          color #515A6E
          font-size 16px

        .ivu-btn
          height 52px
          padding-left 20px
          font-size 20px
          color #ffffff
          border none

        .ivu-input-icon
          line-height 56px

        .ivu-select-arrow
          right 12px
          color #BBC8D2

        .ivu-input-suffix
          display flex
          align-items center

          .scmcc-register-form-item-icon
            width 20px

        .ivu-input-group-append
          color #ffffff
          font-size 16px
          background #04cbd8
          cursor pointer
          position relative
          padding 0
          width 120px
          overflow hidden

        .gray
          background #86E7F2

          .scmcc-register-form-item-checkcode
            position absolute
            top 0
            left 0
            height 100%
            width 100%

        .scmcc-register-form-item-domain
          padding 10px
          font-size 8px

      .ivu-form-item-label
        padding-bottom 7px
        padding-top 15px

      .scmcc-register-form-label
        display flex
        align-items center
        font-size 8px

        .scmcc-register-form-icon
          width 13px
          height 13px
          margin-right 4px
</style>
